{
  "name": "@ashdev/codex-plugin-sync-anilist",
  "version": "2.2.2",
  "description": "AniList reading progress sync plugin for Codex",
  "main": "dist/index.js",
  "bin": "dist/index.js",
  "type": "module",
  "files": [
    "dist",
    "README.md"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/AshDevFr/codex.git",
    "directory": "plugins/sync-anilist"
  },
  "scripts": {
    "build": "esbuild src/index.ts --bundle --platform=node --target=node22 --format=esm --outfile=dist/index.js --sourcemap --banner:js='#!/usr/bin/env node'",
    "dev": "npm run build -- --watch",
    "clean": "rm -rf dist",
    "start": "node dist/index.js",
    "lint": "biome check .",
    "lint:fix": "biome check --write .",
    "typecheck": "tsc --noEmit",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest",
    "prepublishOnly": "npm run lint && npm run build"
  },
  "keywords": [
    "codex",
    "plugin",
    "anilist",
    "sync",
    "manga",
    "reading-progress"
  ],
  "author": "Codex",
  "license": "MIT",
  "engines": {
    "node": ">=22.0.0"
  },
  "dependencies": {
    "@ashdev/codex-plugin-sdk": "^2.2.2"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.4",
    "@types/node": "^22.0.0",
    "esbuild": "^0.27.3",
    "typescript": "^5.9.3",
    "vitest": "^4.0.18"
  }
}
